module.exports = __webpack_public_path__ + "assets/fielseg.1b12db58.svg";